import { useEffect, useState } from "react";
import useApiStatus from "../../../../../hooks/useApiStatus";
import ExtraPayService from "../../../../../service/ExtraPayService";

const useUserCard = ({ onError }) => {
  const { isLoading, hasError, isSuccess, setIsLoading, setIsSuccess, setHasError } = useApiStatus({
    isLoading: true,
  });
  const [cardInfo, setCardInfo] = useState();

  const extraPayService = new ExtraPayService(localStorage.getItem("__extraconomy_token"));

  const loadCardInfo = async () => {
    try {
      const response = await extraPayService.getCardByUser(
        localStorage.getItem("__extraconomy_username")
      );

      if (response.messageCode !== 200001) {
        onError(response.messageCode);
        setHasError(true);
        return;
      }

      setCardInfo(response.result);
      setIsSuccess(true);
    } catch (e) {
      setHasError(true);
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadCardInfo();
    return () => {
      setIsLoading();
      setIsSuccess();
      setHasError();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    cardInfo,
    isLoading,
    hasError,
    isSuccess,
  };
};

export default useUserCard;
